var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.title
      ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
          _c("h3", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _vm.generatedCtaLink
            ? _c(
                "a",
                {
                  staticClass: "ml-auto my-auto link-arrow",
                  attrs: { href: _vm.generatedCtaLink }
                },
                [
                  _vm._v(_vm._s(_vm.cta) + " "),
                  _c("span", {
                    staticClass: "arrow-right",
                    domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                  })
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activity
      ? _c(
          "a",
          {
            staticClass: "position-relative",
            attrs: {
              href: _vm.route(
                "nl.activity",
                _vm.activity.slug != null
                  ? { slug: _vm.activity.slug }
                  : { slug: _vm.activity.post_name }
              )
            }
          },
          [
            _c("div", { staticClass: "mx-n24 mx-md-0" }, [
              _c("div", { staticClass: "activity-banner" }, [
                _vm.activity.acf.content && _vm.activity.acf.content.images
                  ? _c("img", {
                      attrs: {
                        src: _vm.activity.acf.content.images[0].url,
                        alt: _vm.activity.post_name
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm.activity.post_name
                    ? _c("h2", { staticClass: "mb-8 text-white title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.activity.post_title
                              ? _vm.activity.post_title
                              : _vm.activity.title.rendered
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activity.acf &&
                  _vm.activity.acf.content &&
                  _vm.activity.acf.content.highlighted_title
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "text-white font-weight-light description"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.activity.acf.content.highlighted_title
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filteredCategories && _vm.filteredCategories.length > 0
                    ? _c(
                        "div",
                        {
                          key: _vm.filteredCategories.length,
                          ref: "tags",
                          staticClass: "tag-row tag-row-lg mt-24"
                        },
                        _vm._l(_vm.filteredCategories, function(
                          category,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index, staticClass: "tag-col" },
                            [
                              _c("div", {
                                staticClass: "tag tag-accent tag-sm",
                                domProps: { innerHTML: _vm._s(category.name) }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }